// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2zoiD","validationTips":"StatementDescriptor_validationTips__12dbL"};